const resolveImgUrl = (imgPath, language) => {
  const imgUrl = `/images/${language}/${imgPath}`;
  return imgPath ? imgUrl : imgPath;
};

export default resolveImgUrl;
